export default __webpack_public_path__ + "static/media/temparature.c6d97800.svg";